export default function (props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle fillOpacity=".421" fill="#FFF" cx="22" cy="22" r="17" />
                <g fill="#222">
                    <path d="M16.667 15h2.666c.369 0 .667.348.667.778v12.444c0 .43-.298.778-.667.778h-2.666c-.369 0-.667-.348-.667-.778V15.778c0-.43.298-.778.667-.778zM24.667 15h2.666c.369 0 .667.348.667.778v12.444c0 .43-.298.778-.667.778h-2.666c-.369 0-.667-.348-.667-.778V15.778c0-.43.298-.778.667-.778z" />
                </g>
            </g>
        </svg>
    );
}
